import React from "react";
import styled from "styled-components";

const BadgeFree = styled.div`
  height: 20px;
  border-radius: 12px;
  background-color: #dfeaae;
  padding-block: 2px;
`;
const BadgePaid = styled.div`
  height: 20px;
  border-radius: 12px;
  background-color: #ebebeb;
  padding-block: 2px;
`;
const Free = ({ row }) => {
  return (
    <div>
      {row?.isFree ? <BadgeFree>Free</BadgeFree> : <BadgePaid>Paid</BadgePaid>}
    </div>
  );
};

export default Free;
